import { logger } from 'packages';

export const handleAxiosRequest = async (axiosPromise, onError) => {
    let response;
    try {
        response = await axiosPromise;

        if (response.data.errorMessage) {
            onError(response.data.errorMessage);
            return {
                result: response.data,
                success: false
            };
        }
    } catch (err) {
        logger(err);
        onError();
        return {
            result: null,
            success: false
        };
    }
    return {
        result: response.data,
        success: true
    };
};

export const toUserErrorMessage = errorCode => {
    switch (errorCode) {
        case 'START_FAILED':
            return 'BankID-appen verkar inte finnas i din dator eller telefon. Installera den och hämta ett BankID hos din internetbank.';
        case 'EXPIRED_TRANSACTION':
            return 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din Bank. Försök sedan igen.';
        case 'ALREADY_IN_PROGRESS':
            return 'En identifiering för det här personnumret är redan påbörjad. Vänta en stund och försök igen.';
        case 'CERTIFICATE_ERROR':
            return 'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank.';
        case 'CANCELLED':
            return 'Åtgärden avbruten. Försök igen.';
        case 'USER_CANCEL':
            return 'Åtgärden avbruten.';
        default:
            return 'Ett fel uppstod. Försök igen.';
    }
};
